module.exports = __webpack_public_path__ + "202408221624/img/img_card_preview_default.1295bd92.png";